const DIVISIONS: { amount: number; unit: Intl.RelativeTimeFormatUnit }[] = [
  { amount: 60, unit: 'seconds' },
  { amount: 60, unit: 'minutes' },
  { amount: 24, unit: 'hours' },
  { amount: 7, unit: 'day' },
  { amount: 4.34524, unit: 'week' },
  { amount: 12, unit: 'month' },
  { amount: Infinity, unit: 'year' },
];

export function formatRelativeTime(date: number | string | Date, formatter: Intl.RelativeTimeFormat) {
  const timestamp = new Date(date).valueOf();

  const initialTimeDifference = (timestamp - Date.now()) / 1000; // Convert to seconds

  const { value: formattedValue } = DIVISIONS.reduce<{ difference: number; value: string | undefined }>(
    ({ difference, value }, division) => {
      if (value) {
        return { difference, value };
      }

      if (Math.abs(difference) < division.amount) {
        return {
          difference,
          value: formatter.format(Math.round(difference), division.unit),
        };
      }

      return { difference: difference / division.amount, value: undefined };
    },
    { difference: initialTimeDifference, value: undefined },
  );

  if (formattedValue === undefined) {
    throw new Error('Unable to format relative time');
  }

  return formattedValue;
}
